import {
  getFirstAccessibleRoute,
  mergeAuthContext,
} from "utils/accessibleRoutes"

/**
 * Navigate away from an unauthorized screen.
 * Uses the first allowed module, or /forbidden when the user has no module access.
 */
export const navigateToAccessibleRoute = (navigate, partialCtx = {}) => {
  const ctx = mergeAuthContext(partialCtx)
  navigate(getFirstAccessibleRoute(ctx), {
    replace: true,
    state: { accessDenied: true },
  })
}
